<template>
  <form
    accept-charset="utf-8"
    action="/"
    enctype="application/x-www-form-urlencoded"
    id="login"
    method="post"
    role="form"
  >
    <div class="bg-white border-secondary shadow-sm rounded p-3 h-100 mt-2 mb-2">
      <div class="text-step">
        <h5>
          <span class="badge badge-pill badge-warning mr-3">STEP 4</span>
          <span class="title pt-2 mt-2">เปลี่ยนรหัสผ่านสำเร็จ</span>
        </h5>
      </div>
      <div class="mt-3">
        <b-row class="mb-3">
          <b-col cols="12 text-center text-success">
            <i class="far fa-check-circle fa-6x"></i>
            <h4 class="mt-3">เปลี่ยนรหัสผ่านเรียบร้อย</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-3">
            <b-alert variant="secondary" show class="text-center">
              ท่านสามารถ คลิกที่ปุ่ม
              <strong>เพิ่มบัญชีธนาคาร</strong> เพื่อทำการ
              <strong>Login</strong> เข้าสู่ระบบได้ทันที
            </b-alert>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-card class="mt-2" bg-variant="secondary" body-class="p-3">
      <div class="row">
        <div class="col">
          <b-btn type="submit" class="btn golden-btn btn-block" to="/">
            <i class="fas fa-home"></i> ไปหน้าหลัก&nbsp;&nbsp;&nbsp;
          </b-btn>
        </div>
      </div>
    </b-card>
  </form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

export default {
  name: "ForgotPasswordStep4",
  data() {
    return {};
  },
  methods: {
    register(e) {
      e.preventDefault();
      this.$router.push("/member/settings/bank");
    }
  }
};
</script>

<style lang="scss" scoped>
.member-card {
  h5 {
    font-family: SukhumvitBold;
  }
}

.code-input {
  border-color: #bd841b !important;
  width: 40px;
  padding: 0;
  margin: 10px 10px;
  font-size: 25px;
  line-height: 40px;
  height: 40px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

form {
  label {
    font-family: SukhumvitBold;
  }
}

.code-ref {
  font-size: 20px;
  letter-spacing: 5px;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }

  .golden-btn-numpad {
    display: inline-block;
    outline: none;
    /* font-family: inherit; */
    font-family: SukhumvitBold;
    box-sizing: border-box;
    border: none;
    border-radius: 0.2em;
    text-transform: uppercase;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>